import 'reflect-metadata';
import { asEntity } from '../Commons/Decorators/Decorator.asEntity';
import { Convertible } from '../Commons/Decorators/Decorator.Convertible';
import { BaseEntity } from './Base/Base.Entity';

@asEntity()
export class JobEntity extends BaseEntity {
    protected static _apiRoute: string = 'jobs';
    protected static _className: string = 'Jobs';

    // #region fields

    @Convertible()
    name!: string;

    @Convertible()
    status!: 'pending' | 'running' | 'completed' | 'failed' | 'canceled';

    @Convertible()
    message!: string;

    @Convertible()
    result!: boolean;

    @Convertible()
    error!: string;

    @Convertible({ isCreatedAt: true })
    createdAt!: Date;

    @Convertible({ isUpdatedAt: true })
    updatedAt!: Date;

    // #endregion fields
}
